// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyButton__copyButton___I1ybw fa fa-copy","copySuccess":"CopyButton__copySuccess___pJOxv fa fa-check-circle"};